define( [ 'utility' ], function run( utility ) {
	'use strict';

	var mStickyCtaBarFn = {
		init : function( elm ) {
			var onResize,
				tempButton;

			if ( !elm.classList.contains( 'js-m-sticky-cta-bar' ) ) {
				elm.classList.add( 'js-m-sticky-cta-bar' );

				elm.mStickyCtaBar = {}; // Setup mStickyCtaBar object

				if ( 'IntersectionObserver' in window ) {
					// Add a dummy button to the page to get the height of the bar then remove again
					tempButton = utility.htmlStringToElement( '<button class="a-button">M</button>' );
					elm.querySelector( '.l-content-container' ).append( tempButton );
					elm.mStickyCtaBar.maxHeight = tempButton.offsetHeight + 20; // Button height + 20px;
					tempButton.remove();

					if ( elm.offsetHeight > elm.mStickyCtaBar.maxHeight ) {
						elm.classList.add( 'm-sticky-cta-bar--mobile' );
						elm.mStickyCtaBar.mobileLayout = true;
					} else {
						elm.classList.remove( 'm-sticky-cta-bar--mobile' );
						elm.mStickyCtaBar.mobileLayout = false;
					}

					if ( elm.classList.contains( 'm-sticky-cta-bar--primary-only' ) ) {
						elm.mStickyCtaBar.type = 1; /* Primary only at mobile */
					} else if ( elm.classList.contains( 'm-sticky-cta-bar--hidden-mobile' ) ) {
						elm.mStickyCtaBar.type = 2; /* Hidden at mobile */
					} else if ( elm.querySelectorAll( '.a-button' ).length === 1 && !elm.querySelector( '.m-sticky-cta-bar__content' ) ) {
						elm.classList.add( 'm-sticky-cta-bar--primary-only' );
						elm.mStickyCtaBar.type = 1; /* Primary only at mobile */
					} else {
						elm.mStickyCtaBar.type = 0; /* Default type showhide */
					}

					if ( elm.mStickyCtaBar.type === 0 ) {
						mStickyCtaBarFn.showHideContentSetup( elm );
					}

					elm.classList.add( 'is-sticky' );
					elm.setAttribute( 'aria-hidden', true );
					elm.style.display = 'none';
					elm.style.opacity = 0;
					elm.mStickyCtaBar.timeout = undefined;
					elm.mStickyCtaBar.stickyVisible = false;
					elm.mStickyCtaBar.currentBreakpoint = utility.getBreakpoint();

					// Setup an observer from where the bar is within the DOM
					elm.mStickyCtaBar.intersectionElement = document.createElement( 'div' );
					elm.mStickyCtaBar.intersectionElement.style.height = '1px';
					elm.mStickyCtaBar.intersectionElement.style.marginBottom = '-1px';
					elm.insertAdjacentElement( 'beforebegin', elm.mStickyCtaBar.intersectionElement );

					mStickyCtaBarFn.setupObserver( elm );

					// If there is a footer then fade the sticky bar out as soon as the footer comes into view
					elm.mStickyCtaBar.footerElm = document.querySelector( '.m-footer' );
					if ( utility.isNode( elm.mStickyCtaBar.footerElm ) ) {
						elm.mStickyCtaBar.footerObserver = new IntersectionObserver( function listener( entries ) {
							entries.forEach( function loop( entry ) {
								var intersectionElementRect = elm.mStickyCtaBar.intersectionElement.getBoundingClientRect(),
									boundingRect = entry.boundingClientRect.top,
									rootBounds = entry.rootBounds.top,
									boundTest = ( boundingRect - rootBounds ) < elm.mStickyCtaBar.maxHeight;

								if ( elm.mStickyCtaBar.currentBreakpoint === utility.smallTag || elm.mStickyCtaBar.mobileLayout ) {
									rootBounds = entry.rootBounds.bottom;
									boundTest = boundingRect < rootBounds;
								}
								if ( boundTest || intersectionElementRect.bottom > rootBounds ) {
									elm.mStickyCtaBar.stickyVisible = false;
								} else {
									elm.mStickyCtaBar.stickyVisible = true;
								}
								mStickyCtaBarFn.showhideSticky( elm );
							});
						}, {
							threshold : [ 0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1 ],
							rootMargin : '0px',
						});
						elm.mStickyCtaBar.footerObserver.observe( elm.mStickyCtaBar.footerElm );
					}

					onResize = utility.debounce( function listener() {
						var newBreakpoint = utility.getBreakpoint(),
							currentDisplayStyle = elm.style.display,
							currentContentStyle,
							newDisplaySetting;

						elm.style.display = 'block';
						elm.classList.remove( 'm-sticky-cta-bar--mobile' );
						if ( elm.mStickyCtaBar.type === 0 ) {
							currentContentStyle = elm.mStickyCtaBar.showHideContentElm.style.display;
							elm.mStickyCtaBar.showHideContentElm.style.removeProperty( 'display' );
						}
						if ( elm.offsetHeight > elm.mStickyCtaBar.maxHeight ) {
							elm.classList.add( 'm-sticky-cta-bar--mobile' );
							newDisplaySetting = true;
						} else {
							newDisplaySetting = false;
						}
						elm.style.display = currentDisplayStyle;
						if ( elm.mStickyCtaBar.type === 0 ) {
							elm.mStickyCtaBar.showHideContentElm.style.display = currentContentStyle;
						}

						if ( newBreakpoint !== elm.mStickyCtaBar.currentBreakpoint || newDisplaySetting !== elm.mStickyCtaBar.mobileLayout ) {
							elm.mStickyCtaBar.currentBreakpoint = newBreakpoint;
							elm.mStickyCtaBar.mobileLayout = newDisplaySetting;
							mStickyCtaBarFn.setupObserver( elm );
						}
					}, 10 );
					window.addEventListener( 'resize', onResize );
				}

				elm.mStickyCtaBar.open = function open() {
					if ( 'IntersectionObserver' in window && !elm.mStickyCtaBar.showHideOpen ) {
						mStickyCtaBarFn.showHideContentOpen( elm );
					}
				};

				elm.mStickyCtaBar.close = function close() {
					if ( 'IntersectionObserver' in window && ( elm.mStickyCtaBar.currentBreakpoint === utility.smallTag || elm.mStickyCtaBar.mobileLayout ) && elm.mStickyCtaBar.showHideOpen ) {
						mStickyCtaBarFn.showHideContentClose( elm );
					}
				};
			}

			return elm.mStickyCtaBar;
		},

		showhideSticky : function( elm ) {
			if ( ( elm.mStickyCtaBar.currentBreakpoint === utility.smallTag || elm.mStickyCtaBar.mobileLayout ) && elm.classList.contains( 'm-sticky-cta-bar--hidden-mobile' ) ) {
				mStickyCtaBarFn.hideSticky( elm );
			} else if ( elm.mStickyCtaBar.stickyVisible ) {
				mStickyCtaBarFn.showSticky( elm );
			} else {
				mStickyCtaBarFn.hideSticky( elm );
			}
		},

		showSticky : function( elm ) {
			clearTimeout( elm.mStickyCtaBar.timeout ); // Clear any timeout so the element doesn't suddenly disapear

			if ( elm.mStickyCtaBar.type === 0 ) {
				if ( elm.mStickyCtaBar.currentBreakpoint === utility.smallTag || elm.mStickyCtaBar.mobileLayout ) {
					// Collapse the sticky content for the mobile layout
					mStickyCtaBarFn.showHideContentClose( elm, true );
				} else {
					// Display the content as not on mobile layout
					mStickyCtaBarFn.showHideContentOpen( elm, true );
				}
			}

			elm.style.display = 'block';
			elm.setAttribute( 'aria-hidden', false );
			// Delay the opacity change by a tiny bit as otherwise it doesn't transition reliably
			elm.mStickyCtaBar.timeout = setTimeout( function timeoutFn() {
				elm.style.opacity = 1;
			}, 30 );
		},

		hideSticky : function( elm ) {
			clearTimeout( elm.mStickyCtaBar.timeout ); // Clear any timeout so the element doesn't suddenly disapear
			elm.style.opacity = 0;
			// Use a timeout here to prevent the display none overwriting the fade
			elm.mStickyCtaBar.timeout = setTimeout( function timeoutFn() {
				elm.setAttribute( 'aria-hidden', true );
				elm.style.display = 'none';
			}, 510 );
		},

		showHideContentSetup : function( elm ) {
			var buttonText = FRAMEWORK.locale.settings.mStickyCtaBar.mobileText,
				newButtonText = elm.getAttribute( 'data-label' ),
				contentId = utility.makeId();

			if ( newButtonText && newButtonText !== '' ) {
				buttonText = newButtonText;
			}

			elm.classList.add( 'm-sticky-cta-bar--showhide' );

			elm.mStickyCtaBar.showHideOpen = true;
			elm.mStickyCtaBar.showHideButtonElm = utility.htmlStringToElement( '<button class="m-sticky-cta-bar__showhide-button" type="button" aria-controls="' +
				contentId + '" aria-expanded="true">' + buttonText + '</button>' );
			elm.mStickyCtaBar.showHideContentElm = utility.htmlStringToElement( '<div class="m-sticky-cta-bar-content-wrapper" id="' +
				contentId + '" aria-hidden="false"></div>' );
			utility.wrapInner( elm.querySelector( '.l-content-container' ), elm.mStickyCtaBar.showHideContentElm );

			elm.querySelector( '.l-content-container' ).prepend( elm.mStickyCtaBar.showHideButtonElm );

			elm.mStickyCtaBar.showHideButtonElm.addEventListener( 'click', function listener() {
				if ( elm.mStickyCtaBar.showHideOpen ) {
					mStickyCtaBarFn.showHideContentClose( elm );
				} else {
					mStickyCtaBarFn.showHideContentOpen( elm );
				}
			});
		},

		setupObserver : function( elm ) {
			var rootMargin = '0px';

			// If an observer is already setup then remove it first
			if ( elm.mStickyCtaBar.stickyObserver ) {
				elm.mStickyCtaBar.stickyObserver.unobserve( elm.mStickyCtaBar.intersectionElement );
			}
			// Change the rootMargin for mobile so the bar appears and disapears at a different point
			if ( elm.mStickyCtaBar.currentBreakpoint === utility.smallTag || elm.mStickyCtaBar.mobileLayout ) {
				rootMargin = -elm.mStickyCtaBar.maxHeight + 'px';
			}

			elm.mStickyCtaBar.stickyObserver = new IntersectionObserver( function listener( entries ) {
				entries.forEach( function loop( entry ) {
					var rootBounds = entry.rootBounds.top;
					if ( elm.mStickyCtaBar.currentBreakpoint === utility.smallTag || elm.mStickyCtaBar.mobileLayout ) {
						rootBounds = entry.rootBounds.bottom;
					}
					if ( entry.boundingClientRect.bottom > rootBounds ) {
						elm.mStickyCtaBar.stickyVisible = false;
					} else {
						elm.mStickyCtaBar.stickyVisible = true;
					}
					mStickyCtaBarFn.showhideSticky( elm );
				});
			}, {
				threshold : [ 0 ],
				rootMargin : rootMargin,
			});
			elm.mStickyCtaBar.stickyObserver.observe( elm.mStickyCtaBar.intersectionElement );
		},

		showHideContentOpen : function( elm, instant ) {
			if ( elm.mStickyCtaBar.type === 0 ) {
				elm.mStickyCtaBar.showHideButtonElm.classList.add( 'is-open' );
				if ( instant ) {
					elm.mStickyCtaBar.showHideButtonElm.setAttribute( 'aria-expanded', true );
					elm.mStickyCtaBar.showHideContentElm.setAttribute( 'aria-hidden', false );
					elm.mStickyCtaBar.showHideContentElm.style.removeProperty( 'display' );
					elm.mStickyCtaBar.showHideOpen = true;
				} else {
					utility.slideToggle( elm.mStickyCtaBar.showHideContentElm, FRAMEWORK.timings.current.t350ms, {
						variant : 'down',
						callback : function() {
							elm.mStickyCtaBar.showHideButtonElm.setAttribute( 'aria-expanded', true );
							elm.mStickyCtaBar.showHideOpen = true;
						},
					});
				}
			}
		},

		showHideContentClose : function( elm, instant ) {
			if ( elm.mStickyCtaBar.type === 0 ) {
				elm.mStickyCtaBar.showHideButtonElm.classList.remove( 'is-open' );
				if ( instant ) {
					elm.mStickyCtaBar.showHideButtonElm.setAttribute( 'aria-expanded', false );
					elm.mStickyCtaBar.showHideContentElm.setAttribute( 'aria-hidden', true );
					elm.mStickyCtaBar.showHideContentElm.style.display = 'none';
					elm.mStickyCtaBar.showHideOpen = false;
				} else {
					utility.slideToggle( elm.mStickyCtaBar.showHideContentElm, FRAMEWORK.timings.current.t350ms, {
						variant : 'up',
						callback : function() {
							elm.mStickyCtaBar.showHideButtonElm.setAttribute( 'aria-expanded', false );
							elm.mStickyCtaBar.showHideOpen = false;
						},
					});
				}
			}
		},
	};

	return {
		initInstance : function( elm ) {
			return mStickyCtaBarFn.init( elm );
		},
	};
});
